module.exports = __webpack_public_path__ + "static/media/vlecad-logo.ab89a7d5.png";